import * as React from "react";
import { createReactBlockSpec } from "@blocknote/react";
import { AttachmentEditor } from "../AttachmentEditor";
import { MetricSeriesSelect } from "./MetricSeriesSelect";

export const MetricBlock = createReactBlockSpec(
  {
    type: "metric",
    content: "none",
    propSchema: {
      seriesId: {
        default: "",
      },
      value: {
        default: "0",
      },
    },
  },
  {
    render: (props) => (
      <AttachmentEditor type="Metric">
        <MetricSeriesSelect
          value={props.block.props.seriesId}
          onChange={(seriesId) =>
            props.editor.updateBlock(props.block.id, {
              props: { seriesId },
            })
          }
        />
      </AttachmentEditor>
    ),
  },
);
